<div class="increment-number-input flex-row gap-4">
  <div class="control-btn" (click)="decrement()">
    <nw-icon
      type="remove"
      [outlined]="true"
      [size]="10"
      color="black"
    ></nw-icon>
  </div>
  <input
    [(ngModel)]="value"
    type="number"
    class="number-input"
    (change)="onInputChange($event)"
  />
  <div class="control-btn" (click)="increment()">
    <nw-icon type="add" [outlined]="true" [size]="10" color="black"></nw-icon>
  </div>
</div>
